export default "__VITE_ASSET__ad613484__"